import React from 'react';
import PropTypes from 'prop-types';
import { getDisconnectedErrorStatus } from 'lib/selectors/getDisconnectedErrorStatus';
import { useSelector } from 'react-redux';
import MachineMain from '../MachineMain';
import DisconnectedErrorPage from '../DisconnectedErrorPage';

/**
 * Wrapper component that conditionally renders either the main machine interface
 * or a disconnected error page based on connection status.
 */
function MachineMainWrapper({ tab }) {
  const disconnectedErrorStatus = useSelector(getDisconnectedErrorStatus);
  // Show error page if machine is disconnected
  if (disconnectedErrorStatus) {
    return <DisconnectedErrorPage errorStatus={disconnectedErrorStatus} />;
  }

  // Show main machine interface when connected
  return <MachineMain tab={tab} />;
}

MachineMainWrapper.propTypes = {
  /** The currently active tab identifier */
  tab: PropTypes.string,
};

MachineMainWrapper.defaultProps = {
  tab: undefined,
};

export default MachineMainWrapper;
